import React from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { NavLink, Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { FaSun, FaMoon } from 'react-icons/fa';

import './styles.css';

const Header = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Navbar
      fixed="top"
      className="customNavBar"
      variant={theme} // Set variant dynamically ('dark' or 'light')
    >
      <Navbar.Brand className="navbar-logo" as={Link} to="/">
        <img
          alt=""
          src="./../ForFunLab_logo.png"
          width="60"
          height="60"
          className="d-inline-block align-top"
        />{' '}
      </Navbar.Brand>
      <Nav className="ms-auto d-flex flex-row pe-5 align-items-center">
        <NavLink
          className={({ isActive }) => isActive ? "header-item nav-pill mx-4 active" : "header-item nav-pill mx-4"}
          to="/lab-ninjas"
        >
          Lab Ninjas
        </NavLink>
        <NavLink
          className={({ isActive }) => isActive ? "header-item nav-pill mx-4 active" : "header-item nav-pill mx-4"}
          to="/football-predictor"
        >
          Football Predictor
        </NavLink>

        <button
          onClick={toggleTheme}
          className={`theme-toggle-switch ms-3 ${theme}`}
          aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
        >
          <div className="theme-toggle-thumb">
            {theme === 'dark' ? <FaMoon /> : <FaSun />}
          </div>
        </button>
      </Nav>
    </Navbar>
  );
};

export default Header;
